export default {
  pedido: {
    value: null,
    type: 'String',
    maxlength: '20',
    required: false,
    state: null
  },
  responsavelID: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  secaoRH: {
    value: null,
    maxlength: '20',
    required: false,
    state: null
  },
  secaoRHID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  obraRHID: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  inicioObra: {
    value: null,
    maxlength: '10',
    required: true,
    state: null,
    disabled: false
  },
  terminoObra: {
    value: null,
    maxlength: '10',
    required: true,
    state: null,
    disabled: false
  },
  clienteRHID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  equipe: {
    value: null,
    maxlength: '70',
    required: false,
    state: null,
    disabled: false
  },
  paisID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  estadoID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  cidadeID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  observacao: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/employeeboard/board/components/addboard/addboard-form.js